import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=464a685c&scoped=true&lang=pug&"
import script from "./Authorization.vue?vue&type=script&lang=js&"
export * from "./Authorization.vue?vue&type=script&lang=js&"
import style0 from "./Authorization.vue?vue&type=style&index=0&id=464a685c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a685c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464a685c')) {
      api.createRecord('464a685c', component.options)
    } else {
      api.reload('464a685c', component.options)
    }
    module.hot.accept("./Authorization.vue?vue&type=template&id=464a685c&scoped=true&lang=pug&", function () {
      api.rerender('464a685c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/Authorization.vue"
export default component.exports